/**
 * TanStack Query hooks — the app's server state.
 *
 * Reads (health, user status) live here as queries so caching, retry/backoff,
 * deduplication, and polling are handled by TanStack Query rather than hand-
 * rolled effects. Client/UI state stays in the Zustand store (src/store); this
 * module is strictly the server-state boundary, talking to the fetch-based
 * `api` layer.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Backend health — polled so the UI can surface an offline state. */
export function useHealthQuery() {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => api.checkHealth(true),
    refetchInterval: 5 * 60_000,
    staleTime: 60_000,
    retry: 1,
  });
}

/** The signed-in user's membership / rate-limit status. */
export function useUserStatusQuery(figmaUID: string | null | undefined) {
  return useQuery({
    queryKey: ['userStatus', figmaUID],
    queryFn: () => api.getUserStatus(figmaUID as string),
    enabled: !!figmaUID,
    staleTime: 5 * 60_000,
  });
}
